import {inject, IReactComponent} from 'mobx-react';
import {LeftBarComponent} from './LeftBarComponent';

const mapStoresToProps = (stores: any) => ({
    controller: stores.multipartyDashboardStore.leftBarController
});

export const LeftBar = inject(mapStoresToProps)(LeftBarComponent) as IReactComponent;
